<template>
  <v-overlay :value="overlayshow" :z-index="Number.MAX_SAFE_INTEGER">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "DashboardCoreOverlay",
  data() {
    return {
      overlayshow: false,
    };
  },
  watch: {
    "$store.state.overlay.show"() {
      this.overlayshow = this.$store.state.overlay.show;
    },
  },
};
</script>